export const PROJECT_DELETION_TTL = 60 * 60 * 72 // 72 hours in seconds
export const USER_DELETION_TTL = 2 * 7 * 24 * 60 * 60 // 2 weeks in seconds
